module.exports = __webpack_public_path__ + "media/images/icons/da_valutare_valuta-d486cd99aa6423f86c8dc457afb14884.svg";